import {
  ManageSharingSection,
  DetailSection,
  ViewLayout,
  AdvanceStack,
  OtherLayout,
} from '../components';
import { RibbonBar, RibbonDivider } from 'common/components';
import SaveEditTransitionPage from '../components/controls/transition-page/SaveEditTransitionPage';

const TransitionPageDetail = () => {
  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection />
      <ViewLayout disabled />
      <RibbonDivider />
      <SaveEditTransitionPage />
      <RibbonDivider />
      <AdvanceStack isDisabled />
      <OtherLayout ribbonSide='right' isHaveAddOpenItem={false} />
    </RibbonBar>
  );
};

export default TransitionPageDetail;
